<template>
  <path
    d="M9 2.5a.5.5 0 0 0-.85-.358l-2.926 2.85H3.5a1.5 1.5 0 0 0-1.5 1.5v2.99a1.5 1.5 0 0 0 1.5 1.5h1.723l2.926 2.875A.5.5 0 0 0 9 13.5v-11z"
  />
  <path
    d="M10.146 6.146a.5.5 0 0 1 .708 0L12 7.293l1.146-1.147a.5.5 0 0 1 .708.708L12.707 8l1.147 1.146a.5.5 0 0 1-.708.708L12 8.707l-1.146 1.147a.5.5 0 0 1-.708-.708L11.293 8l-1.147-1.146a.5.5 0 0 1 0-.708z"
  />
</template>
